import { Email, Person, Phone, Place, Save, Web, WhatsApp } from '@mui/icons-material'
import { Box, Button, Divider, Stack, TextField, Typography } from '@mui/material'
import React from 'react'

const ContactoTab = ({ contacto, imagenes, editable, setData, handleUpdate }) => {

    const addPunto = () => {
        let prev = [...contacto.puntos_venta];
        prev.push({
            calle: '',
            numero_ext: '',
            numero_int: '',
            codigo_postal: '',
            localidad: '',
            municipio: '',
            estado: '',
            telefono: '',
            whatsapp: '',
            email: ''
        });
        setData({ target: { name: 'puntos_venta', value: prev } });
    }

    const handleChangePunto = (e, index) => {
        let prev = [...contacto.puntos_venta];
        prev[index][e.target.name] = e.target.value;
        setData({ target: { name: 'puntos_venta', value: prev } });
    }

    const removePunto = (index) => {
        let prev = [...contacto.puntos_venta];
        prev = prev.filter((p, i) => i != index);
        setData({ target: { name: 'puntos_venta', value: prev } });
    }

    if (contacto) {
        return (
            <Box sx={{ m: 2 }}>
                <Box sx={{ my: 2 }}>
                    <Typography sx={{ mb: 2 }} variant="h6">Contacto comercial</Typography>
                    {editable ?
                        <Stack direction='column' spacing={1}>
                            <TextField sx={{ mb: 1 }} fullWidth name="nombre" label="Nombre del Contacto" value={contacto.nombre} onChange={setData} />
                            <TextField fullWidth name="calle" label="Calle" value={contacto.calle} onChange={setData} />
                            <Stack direction='row' spacing={1}>
                                <TextField fullWidth type="number" name="numero_ext" label="Número exterior" value={contacto.numero_ext} onChange={setData} />
                                <TextField fullWidth name="numero_int" label="Número interior" value={contacto.numero_int} onChange={setData} />
                                <TextField fullWidth type="number" name="codigo_postal" label="Código Postal" value={contacto.codigo_postal} onChange={setData} />
                            </Stack>
                            <TextField fullWidth name="localidad" label="Localidad" value={contacto.localidad} onChange={setData} />
                            <TextField fullWidth name="municipio" label="Municipio" value={contacto.municipio} onChange={setData} />
                            <TextField fullWidth name="estado" label="Estado" value={contacto.estado} onChange={setData} />
                            <TextField sx={{ my: 1 }} fullWidth name="telefono" label="Teléfono" value={contacto.telefono} type="tel" onChange={setData} />
                            <TextField sx={{ mb: 1 }} fullWidth name="whatsapp" label="WhatsApp" value={contacto.whatsapp} type="tel" onChange={setData} />
                            <TextField sx={{ my: 1 }} fullWidth name="email" label="Correo electrónico" value={contacto.email} type="mail" onChange={setData} />
                        </Stack>
                        :
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Person />
                                <Typography sx={{ ml: 2 }}>{contacto.nombre}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                <Place sx={{ mr: 2 }} />
                                <Typography>{contacto.calle} {contacto.numero_ext}{!['', null].includes(contacto.numero_int) ? ' Int. ' + contacto.numero_int : ''}, {contacto.localidad}, {contacto.municipio}, {contacto.estado} C.P. {contacto.codigo_postal}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                <Phone sx={{ mr: 2 }} />
                                <Typography>{contacto.telefono}</Typography>
                            </Box>

                            {contacto.whatsapp && contacto.whatsapp.length > 8 &&
                                <Box sx={{ display: 'flex', my: 2, alignItems: 'center' }}>
                                    <WhatsApp sx={{ mr: 2 }} />
                                    <Typography>{contacto.whatsapp} </Typography>
                                </Box>
                            }
                            {contacto.email && contacto.email.length > 1 &&
                                <Box sx={{ display: 'flex', mt: 1, alignItems: 'center' }}>
                                    <Email sx={{ mr: 2 }} />
                                    <Typography>{contacto.email} </Typography>
                                </Box>
                            }
                        </Box>
                    }
                </Box>

                <Divider />
                <Box>
                    <Typography sx={{ my: 2 }} variant="h6">Puntos de venta</Typography>
                    {contacto.puntos_venta.map((punto, index) => {
                        if (editable) {
                            return (
                                <Stack direction='column' spacing={1} sx={{ my: 2 }}>
                                    <Typography>Punto de venta {index + 1}</Typography>
                                    <TextField fullWidth name="calle" label="Calle" value={punto.calle} onChange={(e) => handleChangePunto(e, index)} />
                                    <Stack direction='row' spacing={1}>
                                        <TextField fullWidth type="number" name="numero_ext" label="Número exterior" value={punto.numero_ext} onChange={(e) => handleChangePunto(e, index)} />
                                        <TextField fullWidth name="numero_int" label="Número interior" value={punto.numero_int} onChange={(e) => handleChangePunto(e, index)} />
                                        <TextField fullWidth type="number" name="codigo_postal" label="Código Postal" value={punto.codigo_postal} onChange={(e) => handleChangePunto(e, index)} />
                                    </Stack>
                                    <TextField fullWidth name="localidad" label="Localidad" value={punto.localidad} onChange={(e) => handleChangePunto(e, index)} />
                                    <TextField fullWidth name="municipio" label="Municipio" value={punto.municipio} onChange={(e) => handleChangePunto(e, index)} />
                                    <TextField fullWidth name="estado" label="Estado" value={punto.estado} onChange={(e) => handleChangePunto(e, index)} />
                                    <TextField sx={{ my: 1 }} fullWidth name="telefono" label="Teléfono" value={punto.telefono} type="tel" onChange={(e) => handleChangePunto(e, index)} />
                                    <TextField sx={{ mb: 1 }} fullWidth name="whatsapp" label="WhatsApp" value={punto.whatsapp} type="tel" onChange={(e) => handleChangePunto(e, index)} />
                                    <TextField sx={{ my: 1 }} fullWidth name="email" label="Correo electrónico" value={punto.email} type="mail" onChange={(e) => handleChangePunto(e, index)} />
                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button color="error" onClick={() => removePunto(index)} sx={{ my: 2 }} variant="contained">Eliminar Punto</Button>
                                    </Box>
                                    <Divider />
                                </Stack>
                            )
                        } else {
                            return (
                                <Box>
                                    <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                        <Place sx={{ mr: 2 }} />
                                        <Typography>{punto.calle} {punto.numero_ext}{!['', null].includes(punto.numero_int) ? ' Int. ' + punto.numero_int : ''}, {punto.localidad}, {punto.municipio}, {punto.estado} C.P. {punto.codigo_postal}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                        <Phone sx={{ mr: 2 }} />
                                        <Typography>{punto.telefono}</Typography>
                                    </Box>

                                    {punto.whatsapp && punto.whatsapp.length > 8 &&
                                        <Box sx={{ display: 'flex', my: 2, alignItems: 'center' }}>
                                            <WhatsApp sx={{ mr: 2 }} />
                                            <Typography>{punto.whatsapp} </Typography>
                                        </Box>
                                    }
                                    {punto.email && punto.email.length > 1 &&
                                        <Box sx={{ display: 'flex', my: 1, alignItems: 'center' }}>
                                            <Email sx={{ mr: 2 }} />
                                            <Typography>{punto.email} </Typography>
                                        </Box>
                                    }
                                    {
                                        contacto.puntos_venta.length - 1 !== index &&
                                        <Divider />
                                    }
                                </Box>
                            )
                        }
                    })}
                </Box>

                {editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <Button variant="contained" onClick={addPunto}>Agregar Punto de Venta</Button>
                    </Box>
                }
                {editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                    </Box>
                }
            </Box>
        )
    }
}

export default ContactoTab
